import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Security Deposit is built. Reached from
// Payroll > Pay Inputs > Security Deposit in the sidebar flyout.
export const PayInputSecurityDeposit = () => <NotImplemented title="Security Deposit" />;
